import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as HistoryIcon } from "../../../../../assets/images/People/Customers/history.svg";
import { peopleEllipsisSx } from "../../peopleFormValidation";

const historyCardSx = {
  width: "100%",
  maxWidth: 632,
  minHeight: 80,
  borderRadius: "8px",
  border: "1px solid #D5DCE1",
  background: "#FFF",
  p: 2,
  boxSizing: "border-box",
  display: "flex",
  alignItems: "flex-start",
  gap: 1.5,
};

export default function CustomerDetailHistory({ history }) {
  return (
    <Box>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
        History
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {history.map((item) => (
          <Box key={`${item.title}-${item.meta}`} sx={historyCardSx}>
            <Box sx={{ flexShrink: 0, lineHeight: 0, mt: 0.25 }}>
              <HistoryIcon />
            </Box>
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography
                title={item.title}
                sx={{
                  color: "#061522",
                  fontFamily: "Inter",
                  fontSize: 16,
                  fontWeight: 500,
                  lineHeight: "22px",
                  mb: 0.5,
                  ...peopleEllipsisSx,
                }}
              >
                {item.title}
              </Typography>
              <Typography
                title={item.meta}
                sx={{
                  color: "#405261",
                  fontFamily: "Inter",
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "18px",
                  ...peopleEllipsisSx,
                }}
              >
                {item.meta}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
